import React from "react";
import styles from "./TransactionTable.module.css";

const TransactionTable = ({ transactions, loading, onEdit, onDelete }) => {
  if (loading) return <p className={styles.msg}>جاري التحميل...</p>;
  if (!transactions?.length) return <p className={styles.msg}>لا توجد معاملات</p>;

  return (
    <table className={styles.table}>
      <thead>
        <tr>
          <th>العنوان</th>
          <th>المبلغ</th>
          <th>الفئة</th>
          <th>التاريخ</th>
          <th>ملاحظات</th>
          <th>إجراءات</th>
        </tr>
      </thead>
      <tbody>
        {transactions.map((t) => (
          <tr key={t.id}>
            <td>{t.title}</td>
            <td>{t.amount}</td>
            <td>{t.category}</td>
            <td>{new Date(t.transactionDate).toLocaleDateString("ar-EG")}</td>
            <td>{t.notes}</td>
            <td className={styles.actions}>
              <button onClick={() => onEdit(t)} className={styles.editBtn}>تعديل</button>
              <button onClick={() => onDelete(t)} className={styles.deleteBtn}>حذف</button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default TransactionTable;